var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0261 2.12305C20.6215 2.12305 20.2937 1.79516 20.2937 1.39063C20.2937 0.986152 20.6215 0.658203 21.0261 0.658203H30.0607C30.4652 0.658203 30.7931 0.986152 30.7931 1.39063V10.7169C30.7931 11.1215 30.4652 11.4494 30.0607 11.4494C29.6562 11.4494 29.3283 11.1215 29.3283 10.7169V3.15875L16.5161 15.9709C16.2301 16.2569 15.7664 16.2569 15.4804 15.9709L11.4809 11.9714L2.45367 20.9987L1.41797 19.963L10.9631 10.4179C11.2491 10.1319 11.7128 10.1319 11.9988 10.4179L15.9983 14.4174L28.2926 2.12305H21.0261Z",
    fill: "black",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportUp);
export default __webpack_public_path__ + "static/media/report-up.21df7b5f68edf33be19717ec7604c80f.svg";
export { ForwardRef as ReactComponent };